import React, { useState, useEffect, useCallback } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import FontPreload2 from './FontPreload2';
import Header2 from './Header2';
import Footer2 from './Footer2';
import WhatsAppFab from '../components/WhatsAppFab';
import { ThemeContext } from '../ThemeContext';
import { getStoredTheme, applyTheme, teardownTheme } from '../theme';
import '../../../styles/landing2.css';

/**
 * Layout del rediseño de la landing. Envuelve cada página pública con:
 *  - Fuentes nuevas (Source Serif 4 / Hanken Grotesk / IBM Plex Mono / Material Symbols)
 *  - Tema claro/oscuro/auto (data-theme en <html> sólo mientras la landing vive)
 *  - Header2 (con toggle) + Footer2 + FAB de WhatsApp
 *  - Wrapper .ls2 (scoping para no filtrar estilos a /app)
 */
const Landing2Layout = ({ children, title = 'PaySlip — Recibos de nómina, entregados solos' }) => {
  // Estado inicial = tema guardado (lazy). Arrancar en 'auto' provocaba que el
  // efecto de ruta reaplicara el modo stale y pisara el tema guardado en el
  // primer render (toggle en 'dark' pero <html> en 'auto').
  const [mode, setModeState] = useState(() => getStoredTheme());
  const location = useLocation();

  // Aplica el tema al montar y cada vez que cambia el modo (toggle). Sin scroll.
  useEffect(() => {
    applyTheme(mode);
  }, [mode]);

  // Quita data-theme al desmontar la landing (deja /app intacto).
  useEffect(() => () => teardownTheme(), []);

  // En cada cambio de ruta: sube al inicio y reaplica por si /app quitó data-theme.
  useEffect(() => {
    applyTheme(mode);
    window.scrollTo(0, 0);
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  const setMode = useCallback((m) => setModeState(applyTheme(m)), []);

  return (
    <ThemeContext.Provider value={{ mode, setMode }}>
      <Helmet><title>{title}</title></Helmet>
      <FontPreload2 />
      <div className="ls2" style={{ display: 'flex', flexDirection: 'column', overflowX: 'clip' }}>
        <Header2 />
        <main style={{ flex: 1 }}>{children}</main>
        <Footer2 />
        <WhatsAppFab />
      </div>
    </ThemeContext.Provider>
  );
};

export default Landing2Layout;
